import Joi from 'joi-browser';
import React, { useState, useEffect, useRef, createRef, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { TmAddress } from '../../tscapi/model/account';
import { Cookie } from '../../tscapi/utils/cookie';
import { withForm } from '../common/form';
import InfoTooltipSvg from '../common/InfoTooltipSvg';
import Input from '../common/input';
import { Popover, PopoverTrigger, PopoverContent, PopoverArrow, PopoverClose } from '../common/popover';

interface EmailFormProps {
    Password: string;
    Password2: string;
    Offers: boolean;
    CreateAccount: boolean;
}

interface DisplayFormProps {
    selectedAddress: TmAddress;
    emailDataProp: any;
    setEmailDataProp: (any) => void;
    handleSubmit: (any) => void;
    handleBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
    handleFocus: (e: React.FocusEvent<HTMLInputElement>) => void;
    handleChange: (any) => void;
    validate: (arg0: any, arg1: any) => any;
    validateProperty: (arg0: any, arg1: any) => any;
    setSchemaData: (any) => void;
    schema: { any };
    data: any;
    setData: (any) => void;
    setErrors: (any) => void;
    errors: any;
    province: { name: string; id: string }[];
    formState: string;
    touchedFields: Record<string, boolean>;
    editingFields: Record<string, boolean>;
}

export const EmailDisplay = ({
    selectedAddress,
    emailDataProp,
    setEmailDataProp,
    validate,
    setErrors,
    validateProperty,
    handleSubmit,
    handleBlur,
    handleFocus,
    setData,
    data,
    errors,
    handleChange,
    setSchemaData,
    province,
    formState,
    touchedFields,
    editingFields,
}: DisplayFormProps) => {
    // const [addressData, setAddressData] = useState(selectedAddress || {});
    const [emailData, setEmailData] = useState({
        Password: '',
        Password2: '',
        Offers: false,
        CreateAccount: false,
    });
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [isTouched, setIsTouched] = useState(false);

    const Password = createRef();
    const Password2 = createRef();

    const schema = {
        Password: Joi.string()
            .required()
            .min(6)
            .regex(/^(?=.*[0-9])(?=.*[a-zA-Z]).{6,30}$/)
            .label('Password')
            .error((errors) => {
                if (errors[0].type == 'string.min') {
                    return { message: 'Min 6 Characters Required' };
                }
                return {
                    message: t('Password is required.'),
                };
            }),
        Password2: Joi.any()
            .valid(Joi.ref('Password'))
            .required()
            .options({ language: { any: { allowOnly: t('must match password') } } }),
    };
    const schema2 = {
        Password: Joi.any().optional(),

        Password2: Joi.any().optional(),
    };

    const handleCheckboxAccount = ({ currentTarget: input }) => {
        const dataClone = { ...data };
        dataClone[input.name] = input.checked;
        setData(dataClone);
        setEmailDataProp(dataClone);
    };
    const handleCheckboxOffers = ({ currentTarget: input }) => {
        const dataClone = { ...data };
        dataClone[input.name] = input.checked;
        setData(dataClone);
        setEmailDataProp(dataClone);
    };
    const handleChangePassword = ({ currentTarget: input }) => {
        const errorsClone = { ...errors };
        const activeSchema = data.CreateAccount ? schema : schema2;
        const errorMessage = validateProperty(input, activeSchema);
        if (errorMessage) errorsClone[input.name] = errorMessage;
        else delete errorsClone[input.name];
        setErrors(errorsClone);

        const dataClone = { ...data };
        dataClone[input.name] = input.value;
        setData(dataClone);
        setEmailDataProp(dataClone);
    };
    const handleChangeConfirmPassword = ({ currentTarget: input }) => {
        const dataClone = { ...data };
        dataClone[input.name] = input.value;
        setData(dataClone);

        const activeSchema = data.CreateAccount ? schema : schema2;
        const errorMessage = validate(dataClone, activeSchema);
        const errorsClone = { ...errors };
        if (errorMessage) errorsClone[input.name] = errorMessage[input.name];
        else delete errorsClone[input.name];
        setErrors(errorsClone);
        setEmailDataProp(dataClone);
    };
    let timeOutClear;
    const popperStyle = {};
    const handleEnter = () => {
        if (!isTouched) {
            clearTimeout(timeOutClear);
            setIsOpen(true);
        }
    };

    const handleLeave = () => {
        if (!isTouched) {
            timeOutClear = setTimeout(() => setIsOpen(false), 400);
        }
    };
    const handleTouchStart = () => {
        setIsOpen(true);
        setIsTouched(true);
    };
    useEffect(() => {
        if (emailDataProp.CreateAccount == true) {
            setSchemaData(schema);
        } else {
            setSchemaData(schema2);
        }
    }, [emailDataProp]);
    useEffect(() => {
        setSchemaData(schema2);
        setData(emailData);
    }, []);

    return (
        <form className="formWrap" noValidate onSubmit={handleSubmit} style={{ marginTop: '20px' }}>
            <div className="form__wrap">
                <div className="form__left">
                    <div className="checkbox__signup-wrap">
                        <input
                            type="checkbox"
                            id="CreateAccount"
                            name="CreateAccount"
                            value={data.CreateAccount}
                            checked={data.CreateAccount || false}
                            onChange={handleCheckboxAccount}
                            style={{ display: 'none' }}
                        />
                        <label className="checkbox__signup-label" htmlFor="CreateAccount">
                            <div className="checkbox__signup--left">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    className="checkbox__signup--checked"
                                >
                                    <path fill="none" d="M0 0h24v24H0V0z" />
                                    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM17.99 9l-1.41-1.42-6.59 6.59-2.58-2.57-1.42 1.41 4 3.99z" />
                                </svg>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    className="checkbox__signup--unchecked"
                                >
                                    <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
                                    <path d="M0 0h24v24H0z" fill="none" />
                                </svg>
                            </div>
                            <div className="checkbox__signup--right">
                                {t(
                                    'Create a TSC account for faster checkout, interest‑free Easy Pay payments, personalized picks, and more.',
                                )}
                            </div>
                        </label>
                    </div>
                </div>
                <div className="form__right">
                    {data.CreateAccount && (
                        <div className="password__wrap">
                            <div className="password__left">
                                <Input
                                    name="Password"
                                    mask="password"
                                    autoComplete=""
                                    ref={Password}
                                    value={data.Password}
                                    required={true}
                                    label={t('Password')}
                                    error={errors.Password}
                                    onChange={handleChangePassword}
                                />
                                <Input
                                    name="Password2"
                                    ref={Password2}
                                    mask="password"
                                    autoComplete=""
                                    required={true}
                                    value={data.Password2}
                                    label={t('Retype Password')}
                                    error={errors.Password2}
                                    onChange={handleChangeConfirmPassword}
                                />
                            </div>
                            <div className="password__right">
                                <Popover placement="top">
                                    <PopoverTrigger className="popover__button">
                                        <span className="visually-hidden">{t('Password hint')}</span>
                                        <InfoTooltipSvg className="popover__tooltip" />
                                    </PopoverTrigger>
                                    <PopoverContent className="popover__message">
                                        {t(
                                            'Password must have minimum of 6 alphanumeric characters with at least one number.',
                                        )}
                                        <PopoverClose />
                                        <PopoverArrow className="popover__arrow" />
                                    </PopoverContent>
                                </Popover>
                            </div>
                        </div>
                    )}
                    <div id="recaptchaId"></div>
                </div>
            </div>
        </form>
    );
};
export const EmailForm = withForm(EmailDisplay);
